import { notifyError, notifySuccess } from "@/lib/notification";
import * as profileService from "@/services/profile.service";
import { ProfileType, ProfileUpdateType } from "@/services/profile.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const profileKey = {
  all: ["profile"] as const,
  detail: () => [...profileKey.all, "detail"] as const,
};

export const useProfileQuery = () =>
  useQuery({
    queryKey: profileKey.detail(),
    queryFn: profileService.fetchProfile,
  });

export const useUpdateProfileMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<ProfileType, AxiosError, ProfileUpdateType>({
    mutationFn: profileService.updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileKey.detail() });
      notifySuccess("Profile updated successfully");
    },
    onError: (error: any) => {
      const apiError =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to update profile";
      notifyError(apiError);
    },
  });
};
